import React, { useState, useEffect, useRef } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ErrorMessage from '../ErrorMessage';
import LoadingIndicator from '../LoadingIndicator';
import { getPaymentUrl } from './PaymentService';

const PaymentGateWay = () => {
  const { t } = useTranslation();
  const { qr } = useParams();
  const [searchParams] = useSearchParams();
  const paytagid = searchParams.get('qr');
  const qrValue = qr || paytagid;

  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const hasFetched = useRef(false);

  useEffect(() => {
    if (!qrValue) {
      setError(t('payment.missingQr'));
      setIsLoading(false);
      return;
    }

    if (hasFetched.current) return;
    hasFetched.current = true;

    async function fetchData() {
      try {
        const data = await getPaymentUrl(qrValue);
        console.log('data: ', data);

        if (data.code === 0) {
          window.location.href = data.url;
        } else {
          setError(data.message || t('payment.unknownServerError'));
          setIsLoading(false);
        }
      } catch (err) {
        console.error('PaymentGateWay fetch error:', err);
        const details = err?.message || t('payment.unknownError');
        setError(`${t('payment.fetchErrorPrefix')}${details}`);
        setIsLoading(false);
      }
    }

    fetchData();
  }, [qrValue, t]);

  return (
    <div>
      {error && <ErrorMessage message={error} />}
      {isLoading && <LoadingIndicator text={t('payment.loading')} />}
    </div>
  );
};

export default PaymentGateWay;